import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { usePermissao } from '../hooks/usePermissao';

const cor = '#B51013';

export default function RotaProtegida({ children, acao }) {
  const usuario = useAuthStore((s) => s.usuario);
  const carregando = useAuthStore((s) => s.carregando);
  const { pode } = usePermissao();

  if (carregando) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', color: cor, fontSize: '16px',
      }}>
        Carregando...
      </div>
    );
  }

  if (!usuario) return <Navigate to="/login" replace />;
  if (acao && !pode(acao)) return <Navigate to="/acesso-negado" replace />;

  return children;
}
